import { render, staticRenderFns } from "./TaskComplet.vue?vue&type=template&id=1d80ad46&scoped=true"
import script from "./TaskComplet.vue?vue&type=script&lang=js"
export * from "./TaskComplet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d80ad46",
  null
  
)

export default component.exports